


import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import requestService from "@/service/requestService";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";
import { Getter, Action } from "vuex-class";
import Number from "@/shared/filters/Number";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Utils } from "@/service/util";
import { UserService } from "@/service/UserService";
import { ElForm } from "element-ui/types/form";
import { ElButton } from "element-ui/types/button";
import InputNumber from "@/components/common/input/InputNumber.vue";
import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import { RyoukinRank, Hikazei3, HikazeiRyoukin } from "@/model/RyoukinRank";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { Item } from "@/model/ShakenShohiyou";
import InspectionCostPage from "@/page/user/InspectionCostPage.vue";


@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    JibaiseikiDialog,
    JuuryouzeiDialog,
    TopBarTitle
  }
})
export default class QuickInspectionCostComponent extends InspectionCostPage {
  isModeModal: boolean = true;
  isModeQuick: boolean = true;

  onConfirm() {
    let isConfirmCopied: any = 1;
    this.confirm(isConfirmCopied);
    let data = {
      isHikazei: 0, // this.costData.isHikazei, 2021-08-23 sh ひとまず、課税、非課税の概念はないので、0固定としておく
      shakenHiyous: this.costData.shakenHiyou.items,
      sknUketsukeUserJouhou: {
        isConfirmHiyou: isConfirmCopied
      },
      sknUketsukeExtendsId: this.uketsukeExtendsId
    };
    this.$set(this, "updating", true);
    this.reqService.saveShohiyou(data).then( // sendSocket:15車検諸費用の編集
      (res: any) => {
        this.isChangeShohiyou = false;
        this.$set(this, "updating", false);
        this.updateShakenHiyou(res);
      },
      (error: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.formData.zeiJibaisekiZn = this.formData.zeiJibaisekiZk;
        if (this.isMadoguchiInshidaiChecked) {
          this.formData.zeiInshidaiZn = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiZk = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiGenka = this.inshidaiMadoguchi;
        }
        this.formData.isMadoguchiInshidai = this.isMadoguchiInshidaiChecked ? 1 : 0;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
        };
        /** 2021-10-01 sh #7438 implements tech info amount. [START] */
        /** 送る必要がないので、除外する */
        delete data.zeiTechInfoAmountZk;
        delete data.zeiTechInfoAmountZn;
        delete data.isUseTechInfoAmount;
        /** 2021-10-01 sh #7438 implements tech info amount. [END] */
        this.saveTaxAndRefresh(data);
      }
    });
  }

  updateKensaHiyou() {
    let data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      isHikazei:  this.costData.kensaHiyou.isHikazei, // 2021-08-23 sh #7361 fix bug. it does not update kensaHiyou.
      subTotalZn: this.costData.kensaHiyou.subTotalZn ? this.costData.kensaHiyou.subTotalZn: 0,
      subTotalZk: this.costData.kensaHiyou.subTotalZk ? this.costData.kensaHiyou.subTotalZk: 0,
      modeQuick: 1 // 一時的な対応：簡単見積機能を税込税抜切り替え対象から外す
    };
    // extends元の様に別関数で切り出し
    let promise = this.updateKensaHiyouPM(data);
    Promise.all([promise]).then(() => {});
  }

  updateKensaHiyouPM(data: any) {
    let promise = new Promise((resolve, reject) => {
      this.reqService.updateKensaHiyou(data).then( // sendSocket:17車検検査費用と車検基本費用の編集
        (res: any) => {
          this.isEditKensaHiyou = false;
          const userService = new UserService();
          userService.getShohiyouQM();
        },
        (error: any) => {
          this.$notify.error({
            title: "エラー",
            message: MESSAGE.SystemError
          });
          reject();
        }
      );
    });
    return promise;
  }
  
    resetKensaHiyou() {
    this.reqService.resetKensaHiyouQM(this.uketsukeExtendsId).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyouQM();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

  /** 2021-10-11 sh implements tech-info-amount for quick mitsumori. [START] */
  onChangeTechInfoAmount(isUseTechInfoAmount: boolean)  {
    const saveData = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      useTechInfoAmount: isUseTechInfoAmount ? 1 : 0
    };

    this.reqService.updateUseTechInfoAmount(saveData).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyouQM();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー(update tech-info)",
          message: MESSAGE.SystemError
        });
      }
    );
  }
  /** 2021-10-11 sh implements tech-info-amount for quick mitsumori. [END] */
}
